<div class="policy-page">
  <!-- Документы из конфигурации -->
  <app-login-policy [pageName]="'policy'" (close)="close()"></app-login-policy>

  <div class="policy-page__version">{{ APP_VERSION }}</div>
</div>
